import { createIcon } from '../create-icon'

// Eye — map awareness and vision control
export const GpiVision = createIcon('GpiVision', ({ strokeWidth }) => (
  <>
    <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" strokeWidth={strokeWidth} />
    <circle cx="12" cy="12" r="3" strokeWidth={strokeWidth} />
  </>
))
